import { useMemo } from 'react';
import { getUrlParams } from '../../utils/tools';

var passThrough = function passThrough(val) {
  return val;
};

function useUrlParams(name, calculator) {
  var _calc = calculator || passThrough;

  var value = getUrlParams(name);
  var memoizedValue = useMemo(function () {
    return _calc(value);
  }, [_calc, value]);
  return memoizedValue;
}

export { useUrlParams };